<template>
  <div class="Equipment">
    <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <!-- <div class="box">
        <div class="tab" @click="changeTabs('a')"><p>停机设备</p><div class="tabsLine" :class="activeName === 'a' ? '' : 'none'"></div></div>
        <div class="tab" @click="changeTabs('b')"><p>超流量设备</p><div class="tabsLine" :class="activeName === 'b' ? '' : 'none'"></div></div>
        <div class="tab" @click="changeTabs('c')"><p>机卡分离停机</p><div class="tabsLine" :class="activeName === 'c' ? '' : 'none'"></div></div>
      </div> -->
      <van-search v-model="paramsList.iccid" show-action placeholder="请输入要查询的ICCID" @search="onSearch" @cancel="onCancel" />
    </van-sticky>
    <van-tabs v-model="activeName">
      <van-tab title="停机设备" name="a">
        <VANABS type="停机" :total=total :listFlag=listFlag :list=list @changList = changList :searchValue=searchValue></VANABS>
      </van-tab>
      <!-- <van-tab title="超流量设备" name="b">
        <VANABSS :listFlag=listFlag :list=lists @changList = changLists :searchValue=searchValue></VANABSS>
      </van-tab> -->
      <van-tab title="机卡分离导致" name="c">
        <VANABS type="机卡分离" :total=total :listFlag=listFlag :list=listss @changList = changListss :searchValue=searchValue></VANABS>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import VANABS from '@/components/EquipmentvVanTab'
// import VANABSS from '@/components/EquipmentBeyondTab'
import { Equipment, EquipmentBeyond } from '@/api/Equipment.js'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      searchValue: '',
      stickyChangeFlag: false,
      list: [],
      lists: [],
      listss: [],
      total: 0,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: ''
      },
      paramsLists: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: '',
        offReason: '0'
      },
      paramsListss: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: '',
        offReason: '1'
      },
      // list是否有数
      listFlag: 'one',
      closeFlag: false,
      activeName: 'a'
    }
  },
  watch: {
    $route: function (e) {
      if (e.params.id === 'tz') {
        window.document.title = '停机设备'
        this.changeTabs('a')
      } else {
        window.document.title = '机卡分离停机设备'
        this.changeTabs('c')
      }
    }
  },
  computed: {},
  methods: {
    async onSearch () {
      if (this.paramsList.iccid) {
        this.closeFlag = true
      } else {
        this.closeFlag = false
      }
      this.searchValue = this.paramsList.iccid
      this.listFlag = 'three'
      let res
      if (this.activeName === 'a') {
        const data = await Equipment(this.paramsList)
        res = data.data
        this.list = res.extend.rows
        this.total = res.extend.records
        this.$nextTick(_ => {
          if (this.list.length === 0) {
            this.listFlag = 'two'
          } else {
            this.listFlag = 'one'
          }
        })
      } else if (this.activeName === 'c') {
        this.paramsListss.iccid = this.searchValue
        const data = await Equipment(this.paramsListss)
        res = data.data
        this.listss = res.extend.rows
        this.total = res.extend.records
        this.$nextTick(_ => {
          if (this.list.length === 0) {
            this.listFlag = 'two'
          } else {
            this.listFlag = 'one'
          }
        })
      } else {
        this.paramsLists.iccid = this.searchValue
        const data = await EquipmentBeyond(this.paramsLists)
        res = data.data
        this.lists = res.extend.rows
        this.total = res.extend.records
        this.$nextTick(_ => {
          if (this.lists.length === 0) {
            this.listFlag = 'two'
          } else {
            this.listFlag = 'one'
          }
        })
      }
    },
    async onCancel () {
      if (!this.closeFlag) return
      this.listFlag = 'three'
      this.searchValue = ''
      this.paramsList.iccid = ''
      let res
      if (this.activeName === 'a') {
        this.paramsList.iccid = ''
        const data = await Equipment(this.paramsList)
        res = data.data
        this.list = res.extend.rows
        this.total = res.extend.records
      } else if (this.activeName === 'b') {
        this.paramsLists.iccid = ''
        const data = await EquipmentBeyond(this.paramsLists)
        res = data.data
        this.lists = res.extend.rows
        this.total = res.extend.records
      } else {
        this.paramsListss.iccid = ''
        const data = await Equipment(this.paramsListss)
        res = data.data
        this.listss = res.extend.rows
        this.total = res.extend.records
      }
      this.$nextTick(_ => {
        this.listFlag = 'one'
      })
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    changList (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
        this.total = e.total
      } else {
        this.list = []
        this.total = 0
      }
    },
    changLists (e) {
      if (e.type === 'add') {
        this.lists.push(...e.list)
        this.total = e.total
      } else {
        this.lists = []
        this.total = 0
      }
    },
    changListss (e) {
      if (e.type === 'add') {
        this.listss.push(...e.list)
        this.total = e.total
      } else {
        this.listss = []
        this.total = 0
      }
    },
    // 切换工具栏
    changeTabs (e) {
      this.activeName = e
    }
  },
  beforeCreate () {},
  created () {
    if (this.$route.params.id === 'tz') {
      window.document.title = '停机设备'
      this.changeTabs('a')
    } else {
      window.document.title = '机卡分离停机设备'
      this.changeTabs('c')
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .Equipment {
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;
    .van-search {
      width: 750px;
      .van-search__content {
        border-radius: 15px;
      }
    }
  }
  /deep/.van-tabs__content {
    margin-top: 12px;
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
  .box {
    height: 100px;
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    .tab{
      text-align: center;
      font-size: 0.37333rem;
      line-height: 100px;
      position: relative;
    }
    .tabsLine {
      position: absolute;
      bottom: 0.08rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      width: 1.06667rem;
      height: 0.08rem;
      background-color: #ee0a24;
    }
    .none {
      display: none;
    }
  }
  /deep/.van-tabs__wrap {
    display: none;
    height: 0;
  }
</style>
